import sandwich from "../../images/sunkIcon/1-sandwich.png";
import football from "../../images/sunkIcon/2-football.png";
import Grass from "../../images/sunkIcon/3-Grass.png";
import Kindergarten from "../../images/sunkIcon/4-Kindergarten.png";
import Knowledge from "../../images/sunkIcon/5-Knowledge.png";
import Asteroid from "../../images/sunkIcon/Asteroid.png";
import Ketchup from "../../images/sunkIcon/7-Ketchup.png";
import Tuna_1 from "../../images/sunkIcon/Tuna_1.png";
import Beach from "../../images/sunkIcon/9-Beach.png";
import Tuna from "../../images/sunkIcon/10-Tuna.png";

const questions = [
  {
    id: 1,
    title: "Bacon, egg, and cheese sandwich",
    desc: "You are considering whether to buy a bacon, egg, and cheese sandwich from a local cafe.",
    boldText: "",
    answer: "Private Good",
    icon: sandwich,
    description: "The bacon, egg, and cheese sandwich is both rival in consumption and excludable. If you eat the sandwich, there will be none left for someone else, and it is quite possible to limit the sandwich access to only those who pay for one.",
    wrongAnswerText:
      "Not quite! The cost of the lift ticket can't be recovered, so it's a sunk cost.",
    rightAnswerText:
      "Great job! Since you can't get your money back, it's a sunk cost. It should not enter into your decision to stay.",
  },
  {
    id: 2,
    title: "NFL game streaming on Paramount Plus",
    // boldText: "",
    desc: "You want to watch and NFL championship game streaming exclusively on Paramount Plus.",
    answer: "Club Good", //not sunkCost
    icon: football,
    description: "In this case, the streaming service is excludable: you will need to buy a Paramount plus subscription. However, this streaming service is non-rival. One individual's streaming will not prevent someone else from being able to enjoy viewing the same game.",
    wrongAnswerText:
      "Not quite! Since you haven't spent the $15 yet, it's not a sunk cost.",
    rightAnswerText:
      "Great job! Since you haven't spent the $15 yet, it's not a sunk cost.",
  },
  {
    id: 3,
    title: "Walking through a public park",
    boldText: "",
    desc: "You are visiting a new city and you decide to take a walk through their main park, which is uncrowded.",
    answer: "Public Good",
    icon: Grass,
    description: "A public park is both non-excludable and non-rival. Entry is not limited and generally speaking can be enjoyed by very large crowds simultaneously.",
    wrongAnswerText: "Not quite! Since you can't get your money back for the fake tickets, it's a sunk cost.",
    rightAnswerText: "Great job! Since you can't get your money back, it's a sunk cost.",
  },
  {
    id: 4,
    title: "Spot at your local charter school",
    boldText: "",
    desc: "You want to enroll your 5-year-old to attend kindergarten at a publicly-funded local charter school. Because it's popular, it allocates spots via a lottery.",
    answer: "Private Good",
    icon: Kindergarten,
    description: "In this scenario, there are lots of children competing for a limited number of seats at the school. Attendance is rival in that giving the kindergarten spot to one kid means that it cannot be given to another. Attendance is also excludable: the school can limit who attends (based on capacity).",
    wrongAnswerText: "Not quite! Since you can't return your Instant Pot and get your money back, it's a sunk cost.",
    rightAnswerText: "Great job! Since you can't get your money back, it's a sunk cost. The only thing that matters going forward is whether you value the free space in your home over the Instant Pot.",
  },
  {
    id: 5,
    title: "Basic Knowledge",
    desc: "You look up how electricity works on the internet.",
    boldText: "",
    answer: "Public Good",
    icon: Knowledge,
    description: "Basic knowledge is a public good. It is non-excludable as there are several places to learn it, from the library to Wikipedia to Youtube. It is also non-rivalarous, as your knowledge doesn't stop anyone else from learning the same thing.",
    wrongAnswerText:
      "Not quite! Since you can return the jeans for a full refund, your $75 isn't a sunk cost (yet).",
    rightAnswerText:
      "Great job! Since you can return the jeans and get your money back, the $75 isn't a sunk cost (yet).",
  },
  {
    id: 6,
    title: "Asteroid Defense",
    desc: "The government forms a task force to protect the Earth from asteroids.",
    boldText: "",
    answer: "Public Good",
    icon: Asteroid,
    description: "Asteroid defense would be non-rivalrous (you being protected doesn't stop me from being protected) and non-excludable (the entire Earth would be protected).",
    wrongAnswerText:
      "Not quite! Since you can't return the chicken and get your money back, it's a sunk cost.",
    rightAnswerText:
      "Great job! Since you can't return the chicken and get your money back, it's a sunk cost. You should base your dinner decision on what you would prefer.",
  },
  {
    id: 7,
    title: "Restaurant Ketchup",
    desc: "You are at your local fast food restaurant. You go to get some ketchup from the dispenser and find it is almost gone.",
    boldText: "",
    answer: "Common Resource",
    icon: Ketchup,
    description: 'The ketchup is rivalrous, since what you consume will no longer be available for anyone else to eat. However, the ketchup is non-excludable, as anyone at the restauraunt can access it. As such, restaurant ketchup often runs out due to the "Tragedy of the Commons".',
    wrongAnswerText:
      "Not quite! Since you already paid the membership fee, it's a sunk cost.",
    rightAnswerText:
      "Great job! Since you already paid the membership fee, it's a sunk cost. It should not enter into your decision to go to the game.",
  },
  {
    id: 8,
    title: 'Adobe Creative Cloud',
    desc: "You pay a monthly subscription fee to use Adobe's suite of softward products, like Photoshop and Premiere.",
    boldText: "",
    answer: "Club Good",
    icon: Tuna_1,
    description: 'Creative Cloud is a club good. It is excludable, since Adobe limits access to paying subscribers—but it is non-rival. You using photoshop does not stop others from using it.',
    wrongAnswerText:
      "Not quite! Since you haven't driven yet, you can still decide how to use your time.",
    rightAnswerText:
      "Great job! The drive is not a sunk cost. You can decide whether the cost of the drive is worth the enjoyment of the game.",
  },
  {
    id: 9,
    title: "Front row beach spot",
    desc: "Your parents want to wake up early to save a front row beach spot at the public beach this Saturday morning—before the crowds arrive.",
    boldText: "",
    answer: "Common Resource",
    icon: Beach,
    description: "The front row beach spot is rivalrous, as there is a limited number of spaces available. Beach access, however, is not excludable. ",
    wrongAnswerText:
      "Not quite! Since you haven't spent your time yet, it's not a sunk cost.",
    rightAnswerText:
      "Great job! Since you haven't waited an hour in line yet, you can still decide how to use your time at the fair.",
  },
  {
    id: 10,
    title: "Tuna in the sea",
    desc: "You go fishing for tuna and decide to keep what you catch.",
    boldText: "",
    answer: "Common Resource",
    icon: Tuna,
    description: "Wildlife is a classic commone resource. It is non-excludable and rivalrous. As such, almost all governments have policies in place to ensure these resources are not overused.",
    wrongAnswerText:
      "Not quite! Since you haven't spent your time yet, it's not a sunk cost.",
    rightAnswerText:
      "Great job! Since you haven't waited an hour in line yet, you can still decide how to use your time at the fair.",
  },
  // {
  //   id: 10,
  //   title: "State Fair (Part 2)",
  //   desc: "You bought a $20 ticket to the State Fair. Once inside, you want to ride the ferris wheel—but the line is an hour long.",
  //   boldText: "You're deciding whether to ride the ferris wheel. Is the <i>$20 ticket</i> a sunk cost?",
  //   answer: "yes",
  //   icon: Ticket,
  //   wrongAnswerText:
  //     "Not quite! Since you already spent the $20, it's a sunk cost.",
  //   rightAnswerText:
  //     "Great job! Since you already spent the $20, it's a sunk cost.",
  // },
];

export default questions;
